import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import './booking/bookingVars.css';
import './AuthPages.css';

// Where the link in a club's "confirm your email address" email lands. It
// asks for a click rather than confirming on load, so email scanners that
// open links don't confirm it for them.
const VerifyClubEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [state, setState] = useState(token ? 'ready' : 'error');
  const [result, setResult] = useState(null);
  const [error, setError] = useState(token ? '' : 'This link is missing its code. Open it from the email again.');

  const confirm = async () => {
    setState('working');
    try {
      const r = await axios.post('/api/public/club-email/verify', { token });
      setResult(r.data);
      setState('done');
    } catch (err) {
      setError(err.response?.data?.error || "Couldn't confirm it. Try the link again.");
      setState('error');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">Run The Club</div>
        <h1 className="auth-heading">Confirm the club's email</h1>
        {state === 'done' && (
          <p className="auth-success">
            Thanks. <strong>{result.email}</strong> is confirmed for {result.clubName}. Replies to the club's emails will come here, and the club can now send email.
          </p>
        )}
        {state === 'error' && <p className="auth-error">{error}</p>}
        {(state === 'ready' || state === 'working') && (
          <>
            <p>Confirm this address so the club can send emails, with replies coming back to it.</p>
            <button type="button" className="auth-btn auth-btn--primary" onClick={confirm} disabled={state === 'working'}>
              {state === 'working' ? 'Confirming...' : 'Confirm email address'}
            </button>
          </>
        )}
        <div className="auth-links">
          <Link to="/login" className="auth-link">Sign in</Link>
        </div>
      </div>
    </div>
  );
};

export default VerifyClubEmail;
